import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AuthRequiredModal({
  open,
  onClose,
  onLogin,
  title = "Help us keep civic data trustworthy",
  description = "Please create an account to like or dislike this bill. We verify users so every signal we send to representatives reflects real people and helps reduce bots or fake activity.",
  confirmLabel = "Login / Sign Up",
  dismissLabel = "Maybe later",
  footnote = "",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="auth-required-title"
      BackdropProps={{
        sx: { backgroundColor: "rgba(0,0,0,0.35)", backdropFilter: "blur(1px)" }
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          pt: 2,
          px: 2,
          pb: 1.5,
          boxShadow: "0 10px 30px rgba(0,0,0,0.15), 0 2px 10px rgba(0,0,0,0.06)"
        }
      }}
    >
      <IconButton
        onClick={onClose}
        aria-label="Close"
        size="small"
        sx={{ position: "absolute", top: 8, right: 8, color: "#0f172a" }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>

      <DialogTitle id="auth-required-title" sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h6" component="h2" sx={{ fontWeight: 800, letterSpacing: 0.2 }}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="body1" sx={{ color: "text.primary", mb: 0 }}>
            {description}
          </Typography>

          <Divider sx={{ mt: 1.5, mb: 1.5 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Button
              onClick={onLogin}
              size="large"
              variant="contained"
              fullWidth
              sx={{
                py: 1.25,
                fontWeight: 700,
                textTransform: "none",
                borderRadius: 2,
                background:  "var(--teal)", 
              }}
              aria-label={confirmLabel}
            >
              {confirmLabel}
            </Button>

            <Button
              onClick={onClose}
              variant="outlined"
              fullWidth
              sx={{
                py: 1.1,
                textTransform: "none",
                borderRadius: 2,
                fontWeight: 600,
                borderColor: "#0f172a",
                color: "#0f172a",
                "&:hover": { borderColor: "#0f172a", bgcolor: "rgba(15,23,42,0.04)" },
              }}
              aria-label="Close this dialog"
            >
              {dismissLabel}
            </Button>
          </Box>

          {footnote && (
            <Typography
              variant="caption"
              sx={{ display: "block", mt: 1.5, color: "text.secondary" }}
            >
              {footnote}
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ display: "none" }} />
    </Dialog>
  );
}
